const skipCF = (new URLSearchParams(window.location.search)).get('ws-cf') === '0';
module.exports = {
    apiServerUrl: 'https://api-testing.amplement.io',
    publicHostname: 'https://app.testing.my-collaborate.com',
    websocketHostname: skipCF ? 'https://api.testing.amplement.com' : 'https://api-testing.amplement.io',
    debug: true,
    logLevel: 'debug',
    logFilter: 'myc:*',
};
